import React, { ReactElement, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { WalletsDialog } from 'modules/auth/components/WalletsDialog';
import { DeprecatedDialog } from 'modules/deprecatedLiquidStaking/components/DeprecatedDialog/DeprecatedDialog';
import { useHasDeprecatedLSToken } from 'modules/deprecatedLiquidStaking/hooks/useHasDeprecatedLSToken';
import { KnownDialogs, useDialog } from 'modules/dialogs';
import { Layout } from 'modules/layout';

export function RootRoute(): ReactElement {
  const { hasTokens: hasDeprecatedLSToken } = useHasDeprecatedLSToken();
  const { isOpened, onOpen } = useDialog(KnownDialogs.lsDeprecatedDialog);
  const [wasOpened, setWasOpened] = useState(false);

  useEffect(() => {
    if (hasDeprecatedLSToken && !isOpened && !wasOpened) {
      setWasOpened(true);
      onOpen();
    }
  }, [hasDeprecatedLSToken, isOpened, onOpen, wasOpened]);

  return (
    <Layout>
      <Outlet />

      <WalletsDialog />

      <DeprecatedDialog />
    </Layout>
  );
}
